<template>
  <div class="default-monitoring">
    <div class="title">{{ $t('defaultMonitoringLevel') }}</div>
    <Dropdown
      class="dropdown"
      :config="{ inputSize: 48 }"
      :values="levels"
      :placeholder="$t('chooseADefaultMonitoringLevel')"
      :on-change="value => updateDefaultMonitoringLevel(value)"
      :value="defaultLevel"
    >
      <template #placeholder="{ value, isPlaceholder }">
        <MonitoringType v-if="!isPlaceholder" :level="value.level" :label="value.label" />
        <div v-else class="placeholder">{{ value }}</div>
      </template>
      <template #choices="{ choice }">
        <MonitoringType :level="choice.level" :label="choice.label" />
      </template>
    </Dropdown>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown';
import MonitoringType from '@/components/monitoringType';

export default {
  components: { Dropdown, MonitoringType },

  props: {
    company: {
      type: Object,
    },
  },

  data() {
    return {
      defaultLevel: null,
      levels: [],
    };
  },

  watch: {
    company(company) {
      this.defaultLevel = this.levels.find(level => level.publicId === company.defaultPackageLevelPublicId);
    },
  },

  async mounted() {
    const result = await this.$store.dispatch('getPackagesLevel');
    if (result) {
      this.levels = result.items;
    }
    if (this.company) {
      this.defaultLevel = this.levels.find(level => level.publicId === this.company.defaultPackageLevelPublicId);
    }
  },

  methods: {
    updateDefaultMonitoringLevel(level) {
      this.defaultLevel = level;
      this.$store.dispatch('editClient', {
        id: this.company.id,
        defaultPackageLevelPublicId: level.publicId,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.default-monitoring {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 40px;
}
.title {
  color: colors.$darkblue-color;
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 24px;
  width: 100%;
}

.dropdown {
  width: 100%;
  height: 46px;

  :deep(.dropdown) {
    margin-bottom: 0;
  }
}
</style>
